import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetReminderItemDocument,
  ReminderItemDataFragment,
} from '../../types/api/graphql';

export function useReminderItem(id: string | null | undefined) {
  const { data: reminderItemData, loading: reminderItemLoading } =
    useCacheQuery(GetReminderItemDocument, {
      variables: {
        id: id ?? '',
      },
      skip: !id,
    });

  const data = useMemo(
    () => (reminderItemData?.reminder as ReminderItemDataFragment) ?? undefined,
    [reminderItemData?.reminder]
  );

  return {
    data,
    loading: reminderItemLoading,
  };
}
